<template>
  <select class="form-control" :value="value" @change="onChange">
    <option value="">Select Gender</option>
    <option :value="1">Male</option>
    <option :value="0">Female</option>
    <option :value="2">Other</option>
  </select>
</template>

<script>
export default {
  name: 'GenderSelect',
  props: {
    value: [String, Number]
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.value === '' ? '' : Number(e.target.value))
    }
  }
}
</script> 